import useTheme from "../../context/ThemeProvider";
import { LuMoon, LuSun } from "react-icons/lu";


const ThemeToggler = () => {

    const {theme, toggleTheme} = useTheme();

    return (
        <button className="theme-toggler" onClick={() => toggleTheme(theme === "light" ? "dark" : "light")} >
            {
                theme === "dark" 
                ? <LuMoon size="24px" />
                : <LuSun size="24px" />
            }
        </button>
    )
}

export default ThemeToggler;